import React from 'react';
import { BUTTON } from './classnames';
import { BaseButtonProps } from './helpers';
import parseClassnames from '../helpers/parseClassnames';

const BaseButton = React.forwardRef<any, BaseButtonProps>(
  ({ children, as, disabled, href, className = '', ...other }, ref) => {
    let Tag: keyof JSX.IntrinsicElements = 'button';

    if (as) {
      Tag = as;
    } else if (href) {
      Tag = 'a';
    }

    return (
      <Tag
        ref={ref}
        className={parseClassnames(
          className,
          `${BUTTON}${disabled ? ' pointer-events-none' : ''}`,
        )}
        disabled={disabled}
        href={href}
        {...other}
      >
        {children}
      </Tag>
    );
  },
);

export default BaseButton;
